module.exports = __webpack_public_path__ + "img/loading.d79a03e5.gif";